var storefrontApp = angular.module('storefrontApp');
storefrontApp.service('instantLetteringService', ['$http', function ($http) {
    return {
        getFonts: function () {
            return $http.get('storefrontapi/lettering/getfonts');
        },
        generateLetteringDesign: function(genParam){
            return $http.post('storefrontapi/lettering/generateletteringdesign', genParam);
        },
        generateCompoundDesign: function(genParam){
            return $http.post('storefrontapi/lettering/generatecompounddesign', genParam);
        },
        renderLetteringDesign: function(letParams){
            return $http.post('storefrontapi/lettering/renderletteringdesign', letParams);
        },
        renderCompoundDesign: function(compParams){
            return $http.post('storefrontapi/lettering/rendercompounddesign', compParams);
        },
        getInfoLetteringDesign: function(letParams){
            return $http.post('storefrontapi/lettering/getinfoletteringdesign', letParams);
        },
        getInfoCompoundDesign: function(compParams){
            return $http.post('storefrontapi/lettering/getinfocompounddesign', compParams);
        },
        deleteILDesign: function(compParams){
            return $http.post('storefrontapi/lettering/deleteildesign', compParams);
        },
        getExistingLetteringDetails: function (oid, rid, uid) {
            return $http.get('storefrontapi/lettering/getletteringdetails/' + rid + "/" + uid + "/" + oid);
        },
        updateInstantLetteringItem: function (item) {
            return $http.post('storefrontapi/lettering/updateinstantletteringitem', item);
        },
    }
}]);
